module.exports = __webpack_public_path__ + "img/eu.31b52a51.png";